import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'app-kpi-config-three',
    templateUrl: './kpi-config-three.component.html',
    styleUrls: ['./kpi-config-three.component.scss'],
})
export class KpiConfigThreeComponent implements OnInit {
    gridData: GridDataResult;
    sortable = {
        mode: 'single',
        allowUnsort: true,
    };

    sort: SortDescriptor[] = [
        {
            field: 'clientKPIDescription',
            dir: 'asc',
        },
    ];

    allResults: boolean = false;
    scrollable = 'scrollable';

    @Input() data: any[];
    @Input() loading: boolean;
    @ViewChild(GridComponent) grid: GridComponent;
    constructor() {}

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.data?.previousValue == undefined && changes?.data?.currentValue != undefined) {
            this.reloadGrid();
        }
    }

    reloadGrid() {
        try {
            let data = this.data.filter((x) => x.isActive === true);

            this.gridData = {
                data: orderBy(data, this.sort),
                total: data.length,
            };
        } catch (e) {}
    }

    sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.reloadGrid();
    }

    // Range1End == POOR
    // Range2Start == FAIR START
    // Range2End == FAIR END
    // Range3Start == GOOD START
    // Range3End == GOOD END
    // Range4Start == VERY GOOD START
    // Range4End == VERY GOOD END
    // Range5Start == EXCELLENT

    // ENFORCE BOUND CHECKING FOR INPUT FIELDS
    isInvalid(row) {
        row.errors = null;
        let result = false;
        row.errors = [];
        row.range3EndError = false;
        row.range3StartError = false;
        row.range2StartError = false;
        row.range4EndError = false;

        // Base case
        if (
            !row.target ||
            !row.range3Start ||
            !row.range3End ||
            !row.range2Start ||
            !row.range4End
        ) {
            row.errors = ['You must provide values for each field.'];
            return true;
        }
        

        // START scores must be greater than END scores
        if (row.bestScore == 'Lowest') {
            /*if (row.range2Start < row.range2End || row.range3Start < row.range3End || row.range4Start < row.range4End ) {
                result = true;
                row.errors.push('All start values must be less than their respective end values.')
            }*/

            // GOOD START must be greater than target
            if (row.range3Start <= row.target) {
                result = true;
                row.range3StartError = true;
                row.errors.push(
                    `Enter a start value for GOOD that is greater than the TARGET value of ${row.target}.`
                );
            }

            // GOOD end must be less than target
            if (row.range3End >= row.target) {
                result = true;

                row.range3EndError = true;
                row.errors.push(
                    `Enter an end value for GOOD that is less than the TARGET value of ${row.target}.`
                );
            }

            // FAIR start must be greater than FAIR end
            if (row.range2Start <= row.range2End) {
                result = true;

                row.range2StartError = true;
                row.errors.push(
                    `Enter a start value for FAIR that is greater than the FAIR end value of ${row.range2End}.`
                );
            }

            // VERY GOOD start must be greater than VERY GOOD end
            if (row.range4End >= row.range4Start) {
                result = true;

                row.range4EndError = true;
                row.errors.push(
                    `Enter an end value for VERY GOOD that is less than the VERY GOOD start value of ${row.range4Start}.`
                );
            }

            // START scores must be less than END scores
        } else if (row.bestScore == 'Highest') {
            row.errors = [];

            // GOOD start must be less than target
            if (row.range3Start >= row.target) {
                result = true;
                row.range3StartError = true;
                row.errors.push(
                    `Enter a start value for GOOD that is less than the TARGET value of ${row.target}.`
                );
            }

            // GOOD end must be greater than target
            if (row.range3End <= row.target) {
                result = true;
                row.range3EndError = true;

                row.errors.push(
                    `Enter an end value for GOOD that is greater than the TARGET value of ${row.target}.`
                );
            }

            // FAIR start must be less than FAIR end
            if (row.range2Start >= row.range2End) {
                result = true;

                row.range2StartError = true;
                row.errors.push(
                    `Enter a start value for FAIR that is less than the FAIR end value of ${row.range2End}.`
                );
            }

            // VERY GOOD start must be greater than VERY GOOD end
            if (row.range4End <= row.range4Start) {
                result = true;

                row.range4EndError = true;
                row.errors.push(
                    `Enter an end value for VERY GOOD that is greater than the VERY GOOD start value of ${row.range4Start}.`
                );
            }
        }
        return result;
    }

    //
    // AUTO SET RANGES FOR NON-INPUT BANDS
    //

    // If Highest is best, Starting scores should be higher than the score being compared to, ex. Fair should be higher than Poor.
    // If Lowest is best, Starting scores should be lower than the score being compared to, ex. Very Good should be higher than Excellent.
    rangeChange(row, destination: string, origin: string, error: string, isStart: boolean) {
        const amountToChange =
            row.kpiFormat === 'currency' || row.clientKPIDescription === 'FICO' ? 1 : 0.001;
        try {
            if (!row[error]) {
                if (row.bestScore == 'Highest') {
                    if (isStart) {
                        row[destination] = this.determinePrecision(row[origin] - amountToChange);
                    } else {
                        row[destination] = this.determinePrecision(row[origin] + amountToChange);
                    }
                } else if (row.bestScore == 'Lowest') {
                    if (isStart) {
                        row[destination] = this.determinePrecision(row[origin] + amountToChange);
                    } else {
                        row[destination] = this.determinePrecision(row[origin] - amountToChange);
                    }
                }
            }
        } catch (e) {}
    }

    determinePrecision(rangeNumber) {
        if (rangeNumber.toString().split('.')[1] > 3) {
            return Number(rangeNumber.toFixed(3));
        }
        return Number(rangeNumber);
    }
}
